import { useEffect } from 'react'

import window from 'browser-lib/window'
import { endsWith, join } from 'lodash'

import { useLocation } from 'components/ReactRouterProvider/context'

const { userpilot } = window
const { identify, reload, clean } = userpilot ?? {}

export const useTrackUserPilotMovement = () => {
  const location = useLocation()

  useEffect(() => {
    reload?.()
  }, [location])
}

export const logout = () => {
  clean?.()
}

interface OrganizationAttributes {
  manageDocsEnabled?: boolean
}

interface LoginParams {
  email: string
  roles: string[]
  userId: string
  isShadow?: boolean
  highSchoolId: string
  highSchoolName: string
  confirmationDate?: string
  orgIds: string[]
  organizationAttributes?: OrganizationAttributes
}

export const login = ({
  email,
  roles,
  userId,
  isShadow,
  highSchoolId,
  highSchoolName,
  confirmationDate,
  orgIds,
  organizationAttributes,
}: LoginParams) => {
  if (userId && !!identify) {
    const filteredRoles = roles.filter((role) => role !== 'RoleReceiver')
    const staff = endsWith(email, '@scoir.com')
    const adminAccount = filteredRoles.includes('HighSchoolManager')
    const isTeacherOnly = filteredRoles.includes('Teacher') && filteredRoles.length === 1
    identify(userId, {
      id: userId,
      isShadow,
      staff,
      userType: isTeacherOnly ? 'teacher' : 'counselor',
      adminAccount,
      roles: filteredRoles.join(', '),
      created_at: confirmationDate,
      company: { id: highSchoolId, name: highSchoolName, ...organizationAttributes },
      linkedOrgs: join(orgIds, ', '),
    })
  }
}

interface SupporterUserPilotHelperParams {
  id?: string
  hasRecommendationRequests?: boolean
  hasOfficialRequests?: boolean
}

export const useSupporterUserPilotHelper = ({
  id,
  hasRecommendationRequests,
  hasOfficialRequests,
}: SupporterUserPilotHelperParams) => {
  useEffect(() => {
    if (!!id && !!identify && hasRecommendationRequests !== undefined && hasOfficialRequests !== undefined) {
      const roles = []
      if (hasOfficialRequests) {
        roles.push('SchoolOfficial')
      }
      if (hasRecommendationRequests) {
        // do we need to pass the specific non-official type: e.g. Clergy, Teacher?
        roles.push('Recommender')
      }
      identify(id, {
        id,
        roles: JSON.stringify(roles),
        userType: 'supporter',
        company: {
          id: 'offthestreet',
          name: 'offthestreet',
        },
      })
    }
  }, [id, hasOfficialRequests, hasRecommendationRequests])
}

const userPilotHelper = { login, logout }
export default userPilotHelper
